<template>
  <section class="tabs-container" ref="tabs">
    <div :class="{'tab':true,'active':activeName===list.name}" ref="tab" v-for="(list,index) in tabsList" :key="index">
      <span @click="itemClick(list.name,index)">{{list.label}}</span>
    </div>
    <div class="tab-wrap">
      <div class="active-bar" :style="barStyle"></div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Tabs',
  props: {
    activeTab: {
      type: String,
      default: () => {
        return ''
      }
    },
    tabsList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      activeName: '',
      offset: 0,
      clientWidth: 0
    }
  },
  watch: {
    activeTab(val) {
      this.setActive()
    }
  },
  mounted() {
    this.setActive()
  },
  methods: {
    setActive() {
      if (this.tabsList.length > 0) {
        this.tabsList.map((item, index) => {
          if (item.name == this.activeTab) {
            this.itemClick(item.name, index)
          }
        })
      }
    },
    itemClick(val, index) {
      this.$emit('change', val)
      this.activeName = val
      this.clientWidth = parseFloat(this.$refs.tab[index].clientWidth)
      this.offset = parseFloat(this.$refs.tab[index].offsetLeft)
    }
  },
  computed: {
    barStyle() {
      let style = {};
      const width = this.clientWidth + 'px'
      const transform = `translateX(${this.offset}px)`
      style.width = width
      style.transform = transform
      style.msTransform = transform
      style.webkitTransform = transform
      return style
    }
  }
}
</script>

<style lang="scss" scoped>
.tabs-container {
  padding: 0 30px;
  overflow: hidden;
  position: relative;
  .tab {
    float: left;
    margin: 0 7px 13px 0;
    span {
      padding: 0 32px;
      cursor: pointer;
    }
    &.active {
      span {
        color: $theme-color;
      }
    }
  }
  .tab-wrap {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background: #f1f3f8;
    .active-bar {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100px;
      height: 2px;
      background: $theme-color;
      transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    }
  }
}
</style>